export const strings = {
  has_invited: 'katılmanız için sizi davet etti',
  sent_connection_request: 'size bir bağlantı isteği gönderdi',
  has_viewed: 'profilinizi görüntüledi',
  has_requested_to_join: 'katılma talebinde bulundu',
  has_joined: 'katıldı',
  has_published: 'yayımlandı',
  has_posted: 'içinde yayınlandı',
  action_type: '{action} üzerinde var',
  action_types: {
    followings: 'takip etme',
    likes: 'beğenildi',
    comments: 'yorumlandı',
    answers: 'cevaplandı',
    cases: 'dava',
    blogs: 'blog',
    posts: 'gönderildi',
    microsite_posts: 'gönderildi',
    microsite_blogs: 'madde',
  },
  following: 'şimdi {follwowing}',
  liked: '{liked}',
  in_microsite: '{microsite} mikrositesinde',
  client_follow: ' şimdi seni takip ediyor',
  like_post: ' gönderinizi beğendi',
  comment_post: ' gönderinize yorum yaptı',
  like_poll: ' anketinizi beğendi',
  comment_poll: ' anketinize yorum yaptı',
  notifications: 'Bildirimler',
  no_data: 'Bildirim Yok',

  mentions: '{from_client} sizden {sub_entity} {place} adresinde bahsetti',
  commented: '{from_client} sizin {sub_entity} {place}\'inize yorum yaptı',
  posted: '{from_client} {sub_entity} {place} adresini yayınladı',

  replied: '{from_client} {sub_entity} {place} adresinde yanıt verdi',
  followed: '{from_client} {sub_entity} {place} adresini takip etmeye başladı',
  likes: '{from_client} sizin {sub_entity} {place} yerinizi beğendi',
  connection_requests: '{from_client} size bir bağlantı isteği gönderdi',
  client_connections: '{from_client} bağlantı isteğinizi kabul etti',
  profile_views: '{from_client} profilinizi görüntüledi',
  published: '{from_client} {sub_entity} {place} öğesini yayınladı',
  membership_request_recieved:
    '{from_client}, {sub_entity} {place}\'e katılmak için bir istek gönderdi',

  mark_all_as_read: 'Tümünü okundu olarak işaretle',
};